"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _variables = _interopRequireDefault(require("./variables.graphql"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Metrics = function Metrics(props) {
  var value = props.value,
    onChange = props.onChange,
    closeModal = props.closeModal;
  var currentProjectId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentProjectId;
  });
  var _useState = (0, _react.useState)(value || null),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var selectedId = selected ? selected.id : null;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    query: _variables["default"],
    rowKey: "variableId",
    graphqlVariables: {
      groupId: currentProjectId,
      typeFilter: ['quantitative', 'qualitative', 'formula', 'additional_coding', 'summary_usage']
    },
    filter: selectedId ? {
      variableId: selectedId.toString()
    } : {},
    perPage: 10,
    columns: [{
      name: 'variableId',
      label: 'Id',
      filter: true,
      filterSettings: {
        type: 'regex',
        preparePattern: function preparePattern(str) {
          return "^".concat(str, "$");
        }
      }
    }, {
      name: 'key.title',
      label: 'Question',
      filter: true
    }, {
      name: 'key.metric',
      label: 'Metric',
      filter: true
    }, {
      name: 'reportHeader',
      label: 'Variable',
      filter: true
    }, {
      name: 'label',
      label: 'Label',
      filter: true
    }, {
      name: 'survey.label',
      label: 'Survey',
      filter: true
    }],
    onRowClick: function onRowClick(row) {
      setSelected({
        id: row.variableId,
        title: row.label || row['key.metric'],
        type: 'string'
      });
    },
    setRowClass: function setRowClass(row) {
      return selectedId === row.variableId ? _style["default"].selected : '';
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn btn-primary",
    disabled: !selected,
    onClick: function onClick() {
      onChange(selected);
      closeModal();
    }
  }, "Select")));
};
Metrics.propTypes = {
  value: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  onChange: _propTypes["default"].func
};
var _default = exports["default"] = Metrics;